var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEgg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "926.000000pt",
    height: "1280.000000pt",
    viewBox: "0 0 740.8 1280.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.0800000,-0.0800000)",
    fill: "#013300",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4590 12790 c-504 -70 -1061 -319 -1550 -694 -180 -137 -298 -243 -500 -445 -205 -205 -343 -365 -514 -591 -809 -1074 -1427 -2586 -1821 -4455 -397 -1880 -213 -3379 554 -4523 644 -962 1746 -1656 3111 -1960 415 -93 737 -131 945 -113 444 40 933 150 1360 308 677 251 1220 590 1686 1053 235 234 352 373 521 620 794 1159 1050 2750 762 4740 -94 651 -444 1797 -817 2675 -547 1291 -1251 2277 -2015 2823 -359 258 -747 434 -1126 512 -224 47 -470 67 -596 50z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgg);
export default __webpack_public_path__ + "static/media/egg.3ad437734bc0bd40bbd00a3d8bf63311.svg";
export { ForwardRef as ReactComponent };